import React from 'react';

import { AlertTriangleIcon } from 'assets/icons';
import globalStyles from 'assets/stylesheets/global-styles.module.scss';
import styles from './invalid-guest-link.module.scss';

const InvalidGuestLink: React.FC = () => (
  <div className={globalStyles.loggedMainContainer}>
    <div className={styles.container}>
      <div className={styles.titleContainer}>
        <AlertTriangleIcon className={styles.icon} />
        <div>
          <p className="text__heading1__gray800">Oops!</p>
          <p className="text__heading4__gray700">
            We couldn&apos;t find your vault.
          </p>
        </div>
      </div>
      <p className="text__body__regular__medium__gray700">
        Your link is not valid. The vault you&apos;re trying to access might
        have been deleted, or your invitation might have expired.
      </p>
      <p className="text__body__semi__bold__medium__gray800">
        You can request a new invite from the vault owner.
      </p>
    </div>
  </div>
);

export { InvalidGuestLink };
